import { render, staticRenderFns } from "./meal_list.vue?vue&type=template&id=4f8e9782&"
import script from "./meal_list.vue?vue&type=script&lang=js&"
export * from "./meal_list.vue?vue&type=script&lang=js&"
import style0 from "./meal_list.vue?vue&type=style&index=0&id=4f8e9782&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports